// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"1671": "js-legacy","8626": "head-common","878": "stage_automation_icon","9474": "vendor",}[chunkId] + "-" + {"1671": "6c62a3c763bf6e64","8626": "1781f5d734644846","878": "77f578f3c1a744bf","9474": "9d232c738bf07bf5",}[chunkId] + ".js"
}